import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";
import { DateTime } from "luxon";
import { calcPosition } from "../../../../utils/TijdlijnDateCalcUtils";
import styles from "./DienstStartEindeTijd.module.css";

interface IDienstStartEindeTijd {
  dienstTijd: DateTime;
  isBeginTijd?: boolean;
  scale: number;
}

export function DienstStartEindeTijd({
  dienstTijd,
  isBeginTijd = false,
  scale,
}: Readonly<IDienstStartEindeTijd>) {
  const timeLineBegin = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const timeLineEnd = useSelectedTimeStore((state) => state.scenarioInterval?.end)!;

  if (dienstTijd > timeLineEnd || dienstTijd < timeLineBegin) {
    return;
  }

  let left = calcPosition(dienstTijd, timeLineBegin, timeLineEnd, scale);
  if (isBeginTijd) {
    left -= 7;
  }
  return (
    <div
      style={{
        left: left,
      }}
      className={styles["dienst-start-tijd"]}
    ></div>
  );
}
